import { render, staticRenderFns } from "./AdminSearchClaimantModal.vue?vue&type=template&id=2465014e"
import script from "./AdminSearchClaimantModal.vue?vue&type=script&lang=js"
export * from "./AdminSearchClaimantModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports